import { SET_PAGE_LOADING, SET_FORM_LOADING, SET_FORM_PROCESSING, SET_FORM_DIRTY } from '../actions/states'
import _ from 'lodash'

const state = {
  isPageLoading: false,
  isFormLoading: false,
  isFormProcessing: false,
  dirtyForms: []
}

const getters = {
  isPageLoading: state => !!state.isPageLoading,
  isFormLoading: state => !!state.isFormLoading,
  isFormProcessing: state => !!state.isFormProcessing,
  isFormSubmittable: state => !state.isFormLoading && !state.isFormProcessing,
  isFormDirty: state => (formName) => {
    let found = state.dirtyForms.find(form => form.name === formName)

    return found !== undefined && found.dirty === true
  }
}

const actions = {
  [SET_PAGE_LOADING]: ({commit, dispatch}, mode) => {
    return new Promise((resolve, reject) => {
      commit(SET_PAGE_LOADING, mode)
    })
  },

  [SET_FORM_LOADING]: ({commit, dispatch}, mode) => {
    return new Promise((resolve, reject) => {
      commit(SET_FORM_LOADING, mode)
    })
  },

  [SET_FORM_PROCESSING]: ({commit, dispatch}, mode) => {
    return new Promise((resolve, reject) => {
      commit(SET_FORM_PROCESSING, mode)
    })
  },

  [SET_FORM_DIRTY]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit(SET_FORM_DIRTY, payload)
      resolve(payload)
    })
  }
}

const mutations = {
  [SET_PAGE_LOADING]: (state, mode) => {
    state.isPageLoading = !!mode
  },
  [SET_FORM_LOADING]: (state, mode) => {
    state.isFormLoading = !!mode
    state.isFormProcessing = false
  },
  [SET_FORM_PROCESSING]: (state, mode) => {
    state.isFormProcessing = !!mode
    state.isFormLoading = false
  },
  [SET_FORM_DIRTY]: (state, payload) => {
    let data = {
      name: payload.name,
      dirty: payload.mode
    }

    let index = _.findIndex(state.dirtyForms, { name: payload.name })

    if (index === -1) {
      state.dirtyForms.push(data)
    } else {
      let array = _.cloneDeep(state.dirtyForms)
      array[index] = data
      state.dirtyForms = array
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/states.js